import React from "react";
import Frame from "../layout/Frame";
import Meta from "../layout/Meta";
import ServicesList from "../blocks/Services";
import Invite from "../blocks/Invite";

const Services = () => (
  <Frame>
    <Meta title="Services" description="Eight performance advertising services — search, social, programmatic, CTV, retail media, creative testing, CRO, attribution." />
    <section className="svc-hero">
      <div className="shell">
        <div className="crumb"><a href="/">Home</a><span className="sep">/</span>Services</div>
        <span className="tag tag--orange">SERVICES</span>
        <h1 style={{ marginTop: "1.25rem" }}>Eight performance practices, one team.</h1>
        <p className="lede">
          Each is engageable standalone. Most engagements combine three or more — sequenced against where the
          spend is bleeding today and where the next incremental lift actually lives.
        </p>
      </div>
    </section>
    <section className="band">
      <div className="shell">
        <ServicesList />
      </div>
    </section>
    <Invite />
  </Frame>
);

export default Services;
